import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import type { InputDefaultProps } from '../types';
import { CustomInputNumber } from './styles';

const { useFormInstance } = Form;

export function NumberExposed({ fieldName }: Readonly<InputDefaultProps>): JSX.Element {
	const form = useFormInstance();

	const exposedInputs = [
		{
			id: 1,
			title: 'Men',
			required: true,
			name: [fieldName, 'men_exposed'],
			rules: [{ validator: () => validateField('Number of exposed must be greater than 0') }]
		},
		{
			id: 2,
			title: 'Women',
			required: true,
			name: [fieldName, 'women_exposed'],
			rules: [{ validator: () => validateField() }]
		},
		{
			id: 3,
			title: 'Others',
			required: false,
			name: [fieldName, 'other_exposed'],
			rules: [{ validator: () => validateField() }]
		}
	];

	function validateField(message?: string) {
		const total = form.getFieldValue([fieldName, 'total_exposed']);

		if (!total || total === 0) {
			return Promise.reject(I18n.get(message ?? ''));
		}

		return Promise.resolve();
	}

	function handleSetTotalExposed(): void {
		const { men_exposed, women_exposed, other_exposed } = form.getFieldValue(fieldName);
		const total = Number(men_exposed ?? 0) + Number(women_exposed ?? 0) + Number(other_exposed ?? 0);
		form.setFieldValue([fieldName, 'total_exposed'], total);
	}

	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label>Number of exposed</Label>
				</Col>
				<Col span={24}>
					<Row gutter={[40, 0]}>
						{exposedInputs.map(({ id, title, name, rules, required }) => {
							return (
								<Col key={id} span={6}>
									<Row gutter={[0, 5]}>
										<Col span={24}>
											<Label bold={false} isRequired={required}>
												{title}
											</Label>
										</Col>
										<Col span={24}>
											<FormItem name={name} rules={rules} required={required}>
												<CustomInputNumber
													min={0}
													size="large"
													placeholder="0"
													onChange={handleSetTotalExposed}
												/>
											</FormItem>
										</Col>
									</Row>
								</Col>
							);
						})}
						<Col span={6}>
							<Row gutter={[0, 5]}>
								<Col span={24}>
									<Label bold={false}>Total</Label>
								</Col>
								<Col span={24}>
									<FormItem label="Total" name={[fieldName, 'total_exposed']}>
										<CustomInputNumber disabled size="large" placeholder="0" />
									</FormItem>
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
}
